import React from "react";
import "./chooseLanguage.scss";
import SingleLanguage from "./singleLanguage";
import { dataLocalStorage } from "./dataLocalStorage";
// import britain from "url('https://www.countryflags.io/de/flat/32.png')";
import ExpandLess from "@material-ui/icons/ExpandLess";
import { useDispatch, useSelector } from "react-redux";
import { chooseLanguage } from "../../../store/actions/languageAction";
let imgs = [
  "https://www.countryflags.io/us/flat/64.png",
  "https://www.countryflags.io/fr/flat/64.png",
  "https://www.countryflags.io/de/flat/64.png",
  "https://www.countryflags.io/al/flat/64.png",
  "https://www.countryflags.io/es/flat/64.png",
  "https://www.countryflags.io/it/flat/64.png",
  "https://www.countryflags.io/pt/flat/64.png",
  "https://www.countryflags.io/tr/flat/64.png",
  "https://www.countryflags.io/rs/flat/64.png",
];
function ChooseLanguage() {
  const dispatch = useDispatch();
  const language = useSelector((state) => state.language.language);

  const languages = [
    { value: "en-US", language: "English", flag: imgs[0] },
    { value: "fr-FR", language: "French", flag: imgs[1] },
    { value: "de-DE", language: "German", flag: imgs[2] },
    { value: "al-AL", language: "Albanian", flag: imgs[3] },
    { value: "es-ES", language: "Spanish", flag: imgs[4] },
    { value: "it-IT", language: "Italian", flag: imgs[5] },
    { value: "pt-PT", language: "Portugal", flag: imgs[6] },
    { value: "tr-TR", language: "Turkish", flag: imgs[7] },
    { value: "rs-RS", language: "Serbian", flag: imgs[8] },
  ];

  const handleLanguageChange = (language, locale) => {
    dispatch(chooseLanguage(locale));
    dataLocalStorage.setLanguage(language);
    dataLocalStorage.setLocale(locale);
  };

  let flag = null;
  switch (dataLocalStorage.getLocale()) {
    case "en-US":
      flag = imgs[0];
      break;
    case "fr-FR":
      flag = imgs[1];
      break;
    case "de-DE":
      flag = imgs[2];
      break;
    case "al-AL":
      flag = imgs[3];
      break;
    case "es-ES":
      flag = imgs[4];
      break;
    case "it-IT":
      flag = imgs[5];
      break;
    case "pt-PT":
      flag = imgs[6];
      break;
    case "tr-TR":
      flag = imgs[7];
      break;
    case "rs-RS":
      flag = imgs[8];
      break;
    default:
      flag = imgs[0];
  }

  return (
    <div className="choose-language">
      <img src={flag} alt="chosen language" />
      {dataLocalStorage.getLanguage() || "English"}
      <ExpandLess className="arrow" styles="up" />

      <div className="dropdown">
        {languages
          .sort(function (a, b) {
            let language1 = a.language.toUpperCase();
            let language2 = b.language.toUpperCase();
            if (language1 < language2) {
              return -1;
            }
            if (language1 > language2) {
              return 1;
            }
            return 0;
          })
          .map((thisLanguage, i) => {
            return (
              <SingleLanguage
                value={thisLanguage.value}
                key={i}
                handleLanguageChange={() =>
                  handleLanguageChange(
                    thisLanguage.language,
                    thisLanguage.value
                  )
                }
                styles={thisLanguage.value === language && "selected"}
                language={thisLanguage.language}
                flag={thisLanguage.flag}
              ></SingleLanguage>
            );
          })}
      </div>
    </div>
  );
}

export default ChooseLanguage;
